<template>
  <v-container fluid class="will-summary">
    <div v-if="!loading">
      <v-row v-if="notAuthorizedError">
        <v-col cols="12" class="text-center">
          <h3>You are not authorized to view this page</h3>
        </v-col>
      </v-row>
      <v-row v-else no-gutters>
        <v-col cols="12" sm="1">
          <router-link :to="redirectBackLocation" class="back-arrow"
            ><v-icon large color="mid-grey">{{
              icons.mdiArrowLeft
            }}</v-icon></router-link
          >
        </v-col>
        <v-col cols="12" sm="11">
          <v-row no-gutters>
            <v-col cols="12" sm="10">
              <h1>Company Branches</h1>
            </v-col>
            <v-col cols="12" sm="2">
              <v-btn
                depressed
                large
                rounded
                color="primary"
                @click="showAddBranchDialog"
              >
                Add branch
              </v-btn>
            </v-col>
          </v-row>
          <div class="mt-3">
            <CompanyBranchesList
              @showEditBranchDialog="showEditBranchDialog"
              :company-id="companyId"
              :includes-testators="false"
            />
          </div>
        </v-col>
      </v-row>
    </div>
    <div v-else class="text-center">
      <v-progress-circular indeterminate color="primary" />
    </div>
    <BranchDialog v-model="showDialog" :branch-to-update="branchToUpdate" />
    <SuccessSnackbar v-model="showSuccess" :message="successMessage" />
  </v-container>
</template>

<script>
  import CompanyDialog from './CompanyDialog.vue';
  import CompanyDetails from './CompanyDetails.vue';
  import CompanyUsersList from './CompanyUsersList.vue';
  import SuccessSnackbar from '../../common/SuccessSnackbar.vue';
  import CompanyBranchesList from './CompanyBranchesList.vue';
  import BranchDialog from './BranchDialog.vue';
  import { COMPANY_BRANCHES_QUERY } from '../../../constants/graphql/branches';

  export default {
    name: 'CompanyPage',
    components: {
      CompanyDialog,
      CompanyDetails,
      CompanyUsersList,
      SuccessSnackbar,
      CompanyBranchesList,
      BranchDialog,
    },
    props: {},
    data() {
      return {
        branchToUpdate: {},
        loading: false,
        notAuthorizedError: false,
        showDialog: false,
        showSuccess: false,
        successMessage: 'Test',
        companyId: undefined,
      };
    },
    methods: {
      showEditBranchDialog(item) {
        this.branchToUpdate = item;
        this.showDialog = true;
      },
      showAddBranchDialog() {
        this.branchToUpdate = { companyId: this.companyId };
        this.showDialog = true;
      },
    },
    computed: {
      redirectBackLocation() {
        if (this.$store.getters.isCompanyAdmin) {
          return '/advisors';
        } else {
          return '/advisors/companies';
        }
      },
    },
    created() {
      this.companyId = this.$route.params.id;
    },
    apollo: {
      companyBranches: {
        query: COMPANY_BRANCHES_QUERY,
        variables() {
          return {
            id: this.$route.params.id,
          };
        },
        fetchPolicy: 'cache-and-network',
        result(response) {
          if (response.data) this.loading = false;
        },
      },
    },
  };
</script>
